import {REMOVER_FILTRO_BAGAGEM} from '../types'

export default function removerFiltroBagagem (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_BAGAGEM
  }
}
